import { Grid } from '@mui/material';
import { t } from 'i18next';
import React, { useState } from 'react';
import CustomTextField from '../formFields/textField';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { signUpSchema } from 'src/config/yup';
import LoaderButton from '../loaderButton/loaderButton';
import { showErrorTost, showSuccessTost } from 'src/constants';
import { UPDATE_USER } from 'src/apiService/apiDeclaration';

const EditCustomerForm = ({ onSuccess, data }) => {
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    control,
    formState: { errors, isValid, isDirty },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(signUpSchema.omit(['password', 'confirmPassword'])),
    defaultValues: {
      ...data,
    },
  });

  const editCustomer = async (body) => {
    setLoading(true);
    try {
      const resp = await UPDATE_USER(data._id, body);
      onSuccess();
      showSuccessTost(resp.message);
    } catch (error) {
      showErrorTost(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <form onSubmit={handleSubmit(editCustomer)}>
      <Grid container spacing={2} xs={12}>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('common.fName')}
            controller={{
              name: 'firstName',
              control: control,
              errors: errors.firstName,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('common.lName')}
            controller={{
              name: 'lastName',
              control: control,
              errors: errors.lastName,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={'Email'}
            controller={{
              name: 'email',
              control: control,
              errors: errors.email,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('common.phone')}
            controller={{
              name: 'phoneNumber',
              control: control,
              errors: errors.phoneNumber,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('common.stAddress')}
            controller={{
              name: 'streetAddress',
              control: control,
              errors: errors.streetAddress,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('common.stNo')}
            controller={{
              name: 'streetNumber',
              control: control,
              errors: errors.streetNumber,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('common.municipality')}
            controller={{
              name: 'municipality',
              control: control,
              errors: errors.municipality,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('signupPage.reference')}
            controller={{
              name: 'reference',
              control: control,
              errors: errors.reference,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('common.city')}
            controller={{
              name: 'city',
              control: control,
              errors: errors.city,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Grid item sm={6} xs={12} sx={{ ml: 'auto' }}>
            <LoaderButton
              buttonText={t('common.edit') + ' ' + t('navMenu.customer')}
              type="submit"
              disabled={!isValid || !isDirty}
              loading={loading}
            />
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default EditCustomerForm;
